<template>
	<div v-if="!isAuthLoaded">Loading...</div>
	<div v-if="isAuthLoaded">
		<div class="nav">
			<router-link to="/museum"><span class="museum">Museum</span></router-link>
			<router-link to="/wardrobe">
				<span class="wardrobe">Wardrobe</span>
			</router-link>
			<router-link to="/others"><span class="others">Others</span></router-link>
			<router-link to="/user"><span class="user">User</span></router-link>
		</div>
		<router-view />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	mounted() {
		this.start();
	},
	methods: mapActions(['start']),
	computed: mapGetters(['isAuthLoaded']),
};
</script>

<style lang="scss">
:root {
	--color-beige-light: #f3e9bc;
	--color-beige-lighter: #f7f3de;
	--color-green: #cec307;
	--color-brown: #7d6f4a;
	--color-brown-light: #c9a790;
	--color-orange: #f7cb69;
	--color-brownish: #897969;
	--color-teal: #01afb6;
	--color-blue-dark: #4c5aa1;
	--color-blue: #5bcff4;
	--color-teal-light: #bfe5d8;

	--filter-brownish: invert(47%) sepia(4%) saturate(1576%) hue-rotate(349deg)
		brightness(101%) contrast(94%);
	--filter-orange: invert(82%) sepia(87%) saturate(452%) hue-rotate(317deg)
		brightness(102%) contrast(94%);
}

body {
	margin: 0;
	padding: 0;
	font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
	background-color: var(--color-beige-light);
}

button {
	color: var(--color-brown);
	background: var(--color-beige-lighter);
	font-weight: bold;
	border-radius: 4px;
	border-width: 0;
	margin: 3px;
	cursor: pointer;
}

button:hover {
	background-color: var(--color-brown);
	color: var(--color-beige-lighter);
}

button.selected {
	background: var(--color-green);
}

.nav {
	text-align: center;
	margin-bottom: 10px;

	a {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		background: var(--color-beige-lighter);
		margin-right: -15px;
		padding: 0;
		display: inline-block;
		text-indent: -299px;
		overflow: hidden;

		span::before {
			content: ' ';
			display: block;
			width: 80px;
			height: 80px;
			background: no-repeat center center;
			filter: var(--filter-brownish);
			transition: transform 0.2s ease-in;
			background-size: 48px;
		}

		&:hover span::before,
		&.router-link-active:not([exact]) span::before,
		&.router-link-exact-active[exact] span::before {
			filter: var(--filter-orange);
			transform: scale(1.3);
		}

		.museum::before {
			background-image: url(../assets/img/bug.svg);
		}

		.wardrobe::before {
			background-image: url(../assets/img/tshirt.svg);
		}

		.others::before {
			background-image: url(../assets/img/wall.svg);
			background-size: 45px;
		}

		.user::before {
			background-image: url(../assets/img/villager.svg);
			background-size: 45px;
		}
	}
}
</style>
